import {
    GET_TICKET_REQUESTED,
    GET_TICKET_FAILED,
    GET_TICKET_SUCCESS,
    WAIVE_TICKET_REQUESTED,
    WAIVE_TICKET_FAILED,
    WAIVE_TICKET_SUCCESS,
} from './constants';
import { Action } from '../useReducerWithMiddleware';
import { Ticket } from 'types/Ticket';

export type TicketState = {
    tickets: Ticket[] | null;
    errorMessage: string;
    successMessage: string;
    loading: boolean;
};

export const initialTicketState: TicketState = {
    tickets: null,
    errorMessage: '',
    successMessage: '',
    loading: false,
};

export default function ticketReducer(state: TicketState = initialTicketState, action: Action): TicketState {
    switch (action.type) {
        case GET_TICKET_REQUESTED:
        case WAIVE_TICKET_REQUESTED:
            return {
                ...state,
                errorMessage: '',
                successMessage: '',
                loading: true,
            };
        case GET_TICKET_SUCCESS:
            return {
                ...state,
                loading: false,
                tickets: (action.payload as { tickets: Ticket[] }).tickets,
            };
        case GET_TICKET_FAILED:
            return {
                ...state,
                errorMessage: (action.payload as { message: string }).message,
                loading: false,
                tickets: null,
            };
        case WAIVE_TICKET_SUCCESS:
            return {
                ...state,
                loading: false,
                tickets: null,
                successMessage: 'Ticket has been waived.',
                errorMessage: '',
            };
        case WAIVE_TICKET_FAILED:
            return {
                ...state,
                errorMessage: (action.payload as { message: string }).message,
                loading: false,
            };
        default:
            return state || initialTicketState;
    }
}
